module.exports = __webpack_public_path__ + "img/actions_plus.a2cf4553.svg";